import axios from 'axios';

import type {ClientFetchArgs} from './state/api/customBaseQuery';

export const isInIframe = window.self !== window.top;

const edumeClient = axios.create({
  baseURL: '/api',
  headers: {
    platform: 'admin',
    'is-in-iframe': isInIframe,
  },
});

export const edumeClientFetchArgs = {
  baseUrl: '/api',
  prepareHeaders(headers) {
    headers.set('platform', 'admin');
    headers.set('is-in-iframe', `${isInIframe}`);
  },
} as const satisfies ClientFetchArgs;

export default edumeClient;
